// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (min-width:768px){.x-md-center{justify-content:center!important}}", "",{"version":3,"sources":["webpack://./resources/css/app-u768.css"],"names":[],"mappings":"AAAA,oCACI,aACI,gCACJ,CACJ","sourcesContent":["@media screen and (min-width:768px) {\r\n    .x-md-center {\r\n        justify-content: center !important;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
